import { AccommodationRequest } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getAccommodationFromRequestQuery } from './get-accommodation-from-request-query';

export const getAccommodationFromRequestQueryOptions = (request: AccommodationRequest) =>
  queryOptions({
    queryKey: [getAccommodationFromRequestQuery(request).className, getAccommodationFromRequestQuery(request).toJSON()],
    queryFn: async () => {
      const query = getAccommodationFromRequestQuery(request);
      return await query.first();
    },
    enabled: !!request,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
